export const ENVS = {
  WALLET_CONNECT_PROJECT_ID: process.env.VITE_WALLET_CONNECT_PROJECT_ID,
  ENV: process.env.VITE_ENV
};

export enum EVENT_MESSAGE_NAME_ENUM {
  TELEGRAM_LOGIN_SUCCESS = 'tg-brother:telegram_login',
  SINGPASS_CONNECT_SUCCESS = 'singpass-connect:success'
}
